import { usersCollection, functions } from "../../firebase.config";
import momentTimezone from "moment-timezone";
import router from "../../router";
import { auth } from "firebase";

const state = {
  profile: null,
  colours: [
    "#f6ad55",
    "#f6e05e",
    "#68d391",
    "#4fd1c5",
    "#63b3ed",
    "#7f9cf5",
    "#b794f4",
    "#f687b3",
  ],
  gettingTeammates: false,
  teammates: [],
};

const mutations = {
  SET_PROFILE(state, user) {
    state.profile = user;
  },
  SET_GETTING_TEAMMATES(state, boolean) {
    state.gettingTeammates = boolean;
  },
  SET_TEAMMATES(state, teammates) {
    state.teammates = teammates;
  },
};

const actions = {
  getTeammates({ commit, dispatch }, companyId) {
    commit("SET_GETTING_TEAMMATES", true);
    return usersCollection
      .where("companyId", "==", companyId)
      .get()
      .then((docs) => {
        const teammates = [];
        docs.forEach((doc) => {
          var teammate = doc.data();
          teammate.id = doc.id;
          teammates.push(teammate);
        });
        commit("SET_TEAMMATES", teammates);
        commit("SET_GETTING_TEAMMATES", false);
        return docs;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your teammates",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_GETTING_TEAMMATES", false);
      });
  },
  getUserProfile({ commit, dispatch }, user) {
    return usersCollection
      .doc(user.uid)
      .get()
      .then((userDoc) => {
        const user = userDoc.data();
        commit("SET_PROFILE", user);

        if (user.timezone !== momentTimezone.tz.guess()) {
          dispatch("updateUser", {
            uid: userDoc.id,
            change: { timezone: momentTimezone.tz.guess() },
          });
        }

        return user;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your profile info",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        commit("SET_SIGNING_IN", false);
      });
  },
  updateUser({ dispatch }, payload) {
    return usersCollection
      .doc(payload.uid)
      .update(payload.change)
      .then(() => {
        if (payload.dontFetch) return;
        else return dispatch("getUserProfile", payload);
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t update the server",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
      });
  },
  async createNewUser({ dispatch, commit }, user) {
    const colour = await dispatch("pickColour");

    const userDoc = {
      email: user.email,
      displayName: user.displayName,
      companyId: "",
      teams: [],
      onboarded: false,
      colour: colour,
      photoURL: user.photoURL,
      timezone: momentTimezone.tz.guess(),
    };
    return usersCollection
      .doc(user.uid)
      .set(userDoc)
      .then(() => {
        commit("SET_PROFILE", userDoc);

        return commit("SET_SIGNING_IN", false);
      });
  },
  inviteTeammates({ rootState, dispatch, commit }, teammates) {
    const payload = {
      companyName: rootState.companies.company.name,
      sender: state.profile,
      teammates: teammates,
    };

    teammates.forEach((teammate) => {
      dispatch("arrayUnion", {
        collection: "companies",
        id: state.profile.companyId,
        array: "invites",
        item: teammate.email,
      });
    });

    return functions
      .httpsCallable("sendInvites")(payload)
      .then(() => {
        return;
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t send invites",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off",
        };
        dispatch("fireNotification", notification);
        dispatch("getUserProfile", payload);
      });
  },
  pickColour({ state }) {
    return state.colours[Math.floor(state.colours.length * Math.random())];
  },
};

const getters = {
  profile: (state) => state.profile,
  gettingTeammates: (state) => state.gettingTeammates,
  teammates: (state) => state.teammates,
};

const usersModule = {
  state,
  mutations,
  actions,
  getters,
};

export default usersModule;
